import { UserRoleEnum } from "@sinch/core/entities/serverEnums";
import { UserRoleEnum as UserRole } from "@sinch/core/entities/serverEnums.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

/**
 * Single source of truth for how a user role looks in the app: label.
 *
 * Use these getters wherever a user role is shown.
 * Never hardcode its label in a component, change them here.
 * Every value is shown in the "Entity Identity/UserRole" story.
 */
export const useUserRole = () => {
  const { t } = useTranslation();

  /**
   * Mapping of role statuses to their display properties
   */
  const RoleStatuses = {
    [UserRoleEnum.Admin]: {
      label: t("UserRole.admin"),
    },
    [UserRoleEnum.Worker]: {
      label: t("UserRole.staffMember"),
    },
    [UserRoleEnum.Client]: {
      label: t("UserRole.client"),
    },
  } as Record<UserRoleEnum | UserRole, { label: string }>;
  const getProp = useEntityProps(RoleStatuses);

  const getRoleLabel = getProp<string>("label");

  return { getRoleLabel };
};
